import React, { useState, useEffect } from "react";
import { getCookie } from "../components/Cookie.jsx";
import Switch from "@mui/material/Switch";
import toast from "react-hot-toast";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AlertDialog from "../components/AlertDialog.jsx";
import Select from "react-select";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Box from "@mui/material/Box";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import makeAnimated from "react-select/animated";
import { MultiSelect } from "react-multi-select-component";

const selectStyles = {
  control: (base) => ({
    ...base,
    minHeight: "50px",
  }),
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
};

const AdminManageAccess = () => {
  const TOKEN = getCookie("sqa_token");
  const [accessGroupData, setAccessGroupData] = useState([]);
  const [selectedAccessGroup, setSelectedAccessGroup] = useState(-1);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isAlertOpen, setIsAlertOpen] = useState(false);
  const [dialogData, setDialogData] = useState([]);
  const [options, setOptions] = useState([]);
  const [dashboardData, setDashboardData] = useState([]);
  const [curentDashboardData, setCurrentDashboardData] = useState([]);
  const [filteredDashboards, setFilteredDashboards] = useState([]);
  const [roleName, setRoleName] = useState("");
  const [showInput, setShowInput] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [isEditable, setIsEditable] = useState(false);
  const [roleEnabled, setRoleEnabled] = useState(false);
  const [changedFunctions, setChangedFunctions] = useState({});
  const [initialRoleEnabledState, setInitialRoleEnabledState] =
    useState(roleEnabled);
  const appendDataToParent = (newData) => {
    setAccessGroupData((prevData) => [...prevData, newData]);
  };

  const toggleEdit = () => {
    setIsEditable(!isEditable);
  };

  useEffect(() => {
    getAccessGroups();
    getDashboardData();
  }, []);

  useEffect(() => {
    setInitialRoleEnabledState(roleEnabled);
  }, [roleEnabled]);

  useEffect(() => {
    const transformedOptions = dashboardData?.map((item) => ({
      value: item._id,
      label: item.dname,
    }));
    setOptions(transformedOptions);
  }, [dashboardData]);

  useEffect(() => {
    const filtered = filterDashboardsAndFunctions(
      curentDashboardData,
      dashboardData
    );

    setFilteredDashboards(filtered);
  }, [curentDashboardData, dashboardData]);

  function filterDashboardsAndFunctions(curentDashboardData, dashboardData) {
    const roleSpec = curentDashboardData?.role_specification
      ? curentDashboardData?.role_specification
      : {};

    const filteredDash = Object.keys(roleSpec)?.map((role, index) => {
      let data = dashboardData?.filter((item) => item._id == role)[0];
      return data;
    });

    return filteredDash;
  }

  const getAccessGroups = async () => {
    try {
      const url = `/sqa/api/get_access_groups/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      if (data?.result[0]) {
        setAccessGroupData(data?.result);
      } else {
        setAccessGroupData([]);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDropdownChange = (e) => {
    setSelectedAccessGroup(e.target.value);
    setRoleName(e.target.value);
    setShowInput(false);
  };

  const handleOpenDialog = () => {
    setIsDialogOpen(true);
  };

  const handleOpenAlert = () => {
    setIsAlertOpen(true);
  };
  const handleCloseAlert = () => {
    setIsAlertOpen(false);
  };

  const handleCloseDialog = () => {
    setIsDialogOpen(false);
  };

  const handleSelectChange = (selected) => {
    setSelectedOptions(selected);
  };

  const handleManageAccess = async () => {
    if (selectedAccessGroup === -1) {
      toast.error("Please select access group before submiting.");
      return;
    }

    try {
      const url = `/sqa/api/manage_role/`;
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify({ role_id: parseInt(selectedAccessGroup) }),
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      if (data.success == false) {
        setShowInput(false);
      }
      setCurrentDashboardData(data?.result);

      if (data?.result?.is_active == true) {
        setRoleEnabled(true);
      } else {
        setRoleEnabled(false);
      }
      setShowInput(true);

      getAccessGroups();
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const getDashboardData = async () => {
    try {
      const url = `/sqa/api/get_dashboard_data/`;
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
      });

      if (!response.ok) throw new Error("Network response was not ok");

      const data = await response.json();
      setDashboardData(data?.result);

      if (data?.result.length > 0) {
        setDialogData(data?.result);
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleDashboard = async () => {
    const dashData = selectedOptions.map((selectedOption) => {
      const dashboard = dashboardData.find(
        (item) => item._id === selectedOption.value
      );
      return {
        [dashboard._id]: dashboard.dashboard_fn.map((fn) => fn._id),
      };
    });

    const payload = {
      role_id: parseInt(roleName),
      dashboard_data: dashData,
    };

    try {
      const response = await fetch("/sqa/api/add_role_dashboard_name/", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (data.success) {
        toast.success(data.message);
        setSelectedOptions([]);

        await handleManageAccess();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error submitting data: ", error);
    }
  };

  const deleteDashboard = async (d_id) => {
    const payload = {
      role_id: parseInt(roleName),
      dashboard_id: d_id,
    };

    try {
      const response = await fetch("/sqa/api/delete_role_dashboard/", {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();

      if (data.success) {
        toast.success(data.message);
        await handleManageAccess();
      } else {
        toast.error(data.message);
      }
    } catch (error) {
      console.error("Error submitting data: ", error);
    }
  };

  const handleFunctionNameChange = (dashboardId, functionId, newName) => {
    setChangedFunctions((prev) => ({
      ...prev,
      [dashboardId]: {
        ...prev[dashboardId],
        [functionId]: {
          ...prev[dashboardId]?.[functionId],
          fname: newName,
        },
      },
    }));
  };

  const handleAccessTypeChange = (dashboardId, functionId, newAccessType) => {
    setChangedFunctions((prev) => ({
      ...prev,
      [dashboardId]: {
        ...prev[dashboardId],
        [functionId]: {
          ...prev[dashboardId]?.[functionId],
          access_type: newAccessType,
        },
      },
    }));
  };

  const getAccessType = (dashboardId, fnId) => {
    const roleSpec = curentDashboardData?.role_specification;
    const changedFn = changedFunctions[dashboardId]?.[fnId]?.access_type;

    if (changedFn !== undefined) {
      return changedFn;
    }

    if (
      roleSpec &&
      roleSpec[dashboardId] &&
      roleSpec[dashboardId].includes(fnId)
    ) {
      return "1"; // Access
    }
    return "0"; // No Access
  };

  const saveAllChanges = async () => {
    if (
      Object.keys(changedFunctions).length === 0 &&
      roleEnabled !== initialRoleEnabledState
    ) {
      toast.error("No changes to save");
      return;
    }

    const changesArray = Object.entries(changedFunctions).map(
      ([dashboardId, functions]) => ({
        d_id: dashboardId,
        changedData: Object.entries(functions).map(([fn_id, changes]) => ({
          fn_id,
          ...changes,
        })),
      })
    );

    const payload = {
      dashboardData: changesArray,
      roleId: parseInt(roleName),
      roleAccess: roleEnabled,
    };

    try {
      const response = await fetch("/sqa/api/alter_role_dashboard_data/", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${TOKEN}`,
        },
        body: JSON.stringify(payload),
      });

      if (response.ok) {
        const data = await response.json();
        if (data.success) {
          toast.success(data.message);
        } else {
          toast.error(data.message);
        }
        await handleManageAccess();
        setIsDialogOpen(false);
        setIsAlertOpen(false);
        setChangedFunctions({});
      } else {
        console.error("Failed to save changes");
      }
    } catch (error) {
      console.error("Error saving changes:", error);
    }
  };

  return (
    <>
      <div className="flex flex-row justify-between items-end">
        <div className="w-full flex flex-row gap-6 pt-3 items-end">
          <div className="w-1/2">
            <label
              htmlFor="role"
              className="block text-sm font-medium text-gray-700 font-semibold text-[14px] pb-2"
            >
              User Role Name<span className="text-red-500">*</span>
            </label>
            <select
              id="accessGroups"
              value={selectedAccessGroup}
              onChange={handleDropdownChange}
              className="py-3 px-4 block w-full border border-gray-300 rounded-lg text-sm focus:border-blue-500 focus:ring-0"
            >
              <option disabled value={-1}>
                Select User Role
              </option>
              {accessGroupData?.map((access, index) => (
                <option key={index} value={access._id}>
                  {access.role_name}
                </option>
              ))}
            </select>
          </div>
          <button
            onClick={handleManageAccess}
            className=" px-5 py-2 h-1/2 block bg-blue-500 rounded-md text-white hover:bg-blue-600 mb-1"
          >
            Submit
          </button>
          {/* <div className="flex flex-col w-auto font-semibold text-[14px]">
            <label htmlFor="switch">Enable / Disable Role</label>

            <Switch
              checked={roleEnabled}
              onChange={(e) => setRoleEnabled(e.target.checked)}
            />
          </div> */}
        </div>
        <div
          onClick={handleOpenDialog}
          className="rounded-md border border-blue-500 py-2 px-1 justify-evenly flex flex-row items-center text-blue-500 min-w-[140px] cursor-pointer hover:bg-blue-500 hover:text-white"
        >
          <AddCircleIcon /> <span>New Role</span>
        </div>
      </div>

      {showInput && (
        <>
          <div className="w-full flex flex-row gap-6 pt-3 items-end fade-in">
            <div className="w-1/2">
              <label
                htmlFor="firstName"
                className="block text-sm font-medium text-gray-700 font-semibold text-[14px] pb-2"
              >
                Select Dashboard
              </label>

              <MultiSelect
                options={options}
                value={selectedOptions} // Controlled value
                onChange={handleSelectChange} // Handle changes
                labelledBy="Select a Dashboard"
                className="my-custom-multi-select"
                overrideStrings={{
                  selectSomeItems: "Select Dashboards...", // Custom placeholder text
                  allItemsAreSelected: "All Dashboards are selected", // Custom text when all items are selected
                }}
              />
            </div>
            <button
              onClick={handleDashboard}
              className=" px-5 py-2 h-1/2 block bg-blue-500 rounded-md text-white hover:bg-blue-600"
            >
              Add Dashboard
            </button>
          </div>
          <div className="pt-10  fade-in">
            <div className="py-4 text-center border-t border-l border-r rounded-md font-semibold text-xl">
              Dashboards
            </div>
            {filteredDashboards.map((dashboard, index) => (
              <div key={dashboard._id} className="pb-4 fade-in">
                <Accordion key={dashboard._id}>
                  <AccordionSummary
                    aria-controls={`panel${index + 1}-content`}
                    id={`panel${index + 1}-header`}
                    sx={{
                      bgcolor: "#4880FF",
                      color: "white",
                      borderRadius: "8px",
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      "& .MuiAccordionSummary-content": {
                        fontWeight: "bold",
                        flexGrow: 1,
                        textAlign: "center",
                      },
                    }}
                  >
                    <div className="text-center w-full pl-20 text-lg">
                      {dashboard.dname}
                    </div>
                    <Box sx={{ display: "flex", gap: 1 }}>
                      {/* <Box
                        sx={{
                          bgcolor: "#FFDE4D",
                          borderRadius: "25%",
                          p: 0.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",

                          transition: "background-color 0.3s ease", // Smooth transition
                          "&:hover": {
                            backgroundColor: "#FFB22C", // Background color on hover
                          },
                        }}
                        onClick={(event) => {
                          event.stopPropagation();
                          toggleEdit();
                          // Your edit function here
                        }}
                      >
                        <EditIcon sx={{ color: "white" }} />
                      </Box> */}
                      <Box
                        onClick={(event) => {
                          event.stopPropagation();
                          deleteDashboard(dashboard?._id);
                        }}
                        sx={{
                          bgcolor: "#F5004F",
                          borderRadius: "25%",
                          p: 0.5,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          transition: "background-color 0.3s ease", // Smooth transition
                          "&:hover": {
                            backgroundColor: "#E4003A", // Background color on hover
                          },
                        }}
                      >
                        <DeleteIcon sx={{ color: "white" }} />
                      </Box>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ padding: 1 }}>
                    <div className="rounded-md">
                      <div className="flex flex-row bg-[#E9F2FF] py-3 rounded-md">
                        <div className="w-full text-center flex-1">
                          <p className="font-semibold text-lg">Functionality</p>
                        </div>
                        <div className="w-full text-center flex-1">
                          <p className="font-semibold text-lg">Access Type</p>
                        </div>
                      </div>
                      {dashboard.dashboard_fn.map((fn) => (
                        <div
                          key={fn._id}
                          className="grid grid-cols-2 gap-4 mt-4 border-b border-x py-1 rounded-md items-center "
                        >
                          <div className="col-span-1  text-center">
                            {fn.fname}
                          </div>
                          <div className="col-span-1 text-center">
                            <select
                              className="border p-2 rounded"
                              value={getAccessType(dashboard._id, fn._id)}
                              onChange={(e) =>
                                handleAccessTypeChange(
                                  dashboard._id,
                                  fn._id,
                                  e.target.value
                                )
                              }
                            >
                              <option value="1">Access</option>
                              <option value="0">No Access</option>
                            </select>
                          </div>
                        </div>
                      ))}
                    </div>
                  </AccordionDetails>
                </Accordion>
              </div>
            ))}
          </div>
          <div className="flex justify-center text-lg py-4 fade-in">
            <button
              onClick={handleOpenAlert}
              className="bg-[#4880FF] px-6 py-2 rounded-md text-white hover:bg-blue-600"
            >
              Save Changes
            </button>
          </div>
        </>
      )}

      <AlertDialog
        open={isDialogOpen}
        onClose={handleCloseDialog}
        title="Manage Role and Access"
        description="Confirm if you want to Save Role and Access changes"
        onConfirm={saveAllChanges}
        type="dialog"
        data={dialogData}
        appendData={appendDataToParent}
      />
      <AlertDialog
        open={isAlertOpen}
        onClose={handleCloseAlert}
        title="Manage Role and Access"
        description="Confirm if you want to Save Role and Access changes"
        onConfirm={saveAllChanges}
        type="alert"
        data={dialogData}
      />
    </>
  );
};

export default AdminManageAccess;
